import {
  selectScheduleByNameLimit,
  selectScheduleTaskByName,
  selectScheduleTaskByPage,
} from "../../api";
import { Schedule } from "../../utilis";
import dayjs from "dayjs";
import { MAX_SCHEDULE_LIMIT } from "../../utilis/enum";

const scheduleTask = {
  namespaced: true,
  state: () => ({
    scheduleTask: [],
    todayTasks: [],
    scheduleCenter: new Schedule(),
    showNotifiedTask: false,
    notifiedTask: {
      taskName: "定时任务",
      status: "SCHEDULED",
      executionTime: "",
      createdAt: "",
      content: "",
    },
    scheduleTable: [],
    tableTotal: 0,
    editingSchedule: {},
  }),

  getters: {
    showNotifiedTask: (state) => state.showNotifiedTask,
    notifiedTask: (state) => state.notifiedTask,
    scheduleTask: (state) => state.scheduleTask,
    scheduleTable: (state) => state.scheduleTable,
    tableTotal: (state) => state.tableTotal,
    editingSchedule: (state) => state.editingSchedule,
  },
  mutations: {
    SET_SCHEDULE_TASK(state, task) {
      state.scheduleTask = task;
    },

    SET_SHOW_NOTIFIED(state, show) {
      state.showNotifiedTask = show;
    },

    SET_NOTIFIED_TASK(state, task) {
      state.notifiedTask = task;
    },

    SET_SCHEDULE_TABLE(state, table) {
      state.scheduleTable = table;
    },

    SET_TABLE_TOTAL(state, total) {
      state.tableTotal = total;
    },

    SET_TODAY_TASKS(state, tasks) {
      state.todayTasks = tasks;
    },

    SET_EDITING_SCHEDULE(state, task) {
      state.editingSchedule = task;
    },
  },

  actions: {
    async selectAllScheduleTask({ commit, state }, payload) {
      const { userName } = payload;
      try {
        state.scheduleCenter.off();

        state.scheduleCenter.on("show", (task) => {
          commit("SET_SHOW_NOTIFIED", true);
          const taskContent = {
            taskId: task.taskId,
            taskName: task.taskName,
            taskType: task.taskType,
            status: task.status,
            executionTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            createdAt: task.createTime,
            content: task.description,
          };
          commit("SET_NOTIFIED_TASK", taskContent);
        });

        const response = await selectScheduleTaskByName(userName);
        const allTasks = response.data || [];

        commit("SET_SCHEDULE_TASK", allTasks.slice(0, 5));

        state.scheduleCenter.addTaskList(allTasks);
      } catch (e) {
        console.log("请求所有定时任务出错：" + e);
      }
    },

    async selectScheduleByNum({ commit }, payload) {
      const { userName, num } = payload;
      try {
        const response = await selectScheduleByNameLimit(userName, num);
        if (response.code === 200) {
          commit("SET_SCHEDULE_TASK", response.data);
        }
        const scheduleList = await selectScheduleTaskByName(userName);
        commit("SET_SCHEDULE_TASK", scheduleList.data.slice(0, 5));
      } catch (e) {
        console.log("请求所有定时任务出错：" + e);
      }
    },

    async selectScheduleByPage({ commit }, payload) {
      const { userName, pageNum } = payload;
      try {
        const response = await selectScheduleTaskByPage(
          userName,
          pageNum,
          MAX_SCHEDULE_LIMIT
        );
        if (response.code === 200) {
          commit("SET_SCHEDULE_TABLE", response.data.records);
          commit("SET_TABLE_TOTAL", response.data.total);
        }
      } catch (e) {
        console.error(e);
      }
    },

    setEditingSchedule({ commit }, payload) {
      const { task } = payload;
      commit("SET_EDITING_SCHEDULE", task);
    },

    notifyClosed({ commit, state }) {
      commit("SET_SHOW_NOTIFIED", false);
      state.scheduleCenter.notifyClosed();
    },

    doneSchedule({ commit, state }, task) {
      commit("SET_SHOW_NOTIFIED", false);
      state.scheduleCenter.doneSchedule(task.taskId);
      state.scheduleCenter.notifyClosed();
    },
  },
};

export default scheduleTask;
